import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { Chip } from '@mui/material';
import { format } from 'date-fns';
import { severityColorMap } from '../../types/hardwareErrors';

const baseColumns: GridColDef[] = [
    {
        field: 'errorDate',
        headerName: 'Date',
        width: 160,
        valueFormatter: (value: any) => {
            return value ? format(new Date(value), 'yyyy-MM-dd HH:mm:ss') : '';
        }
    },
    {
        field: 'errorCode',
        headerName: 'Error Code',
        width: 100
    },
    {
        field: 'errorSource',
        headerName: 'Source',
        width: 100
    },
    {
        field: 'errorDescription',
        headerName: 'Description',
        flex: 1,
        minWidth: 250
    },
];

const troubleshootingColumn: GridColDef = {
    field: 'troubleshootingInfo',
    headerName: 'Troubleshooting',
    flex: 1,
    minWidth: 200,
};

const severityColumn: GridColDef = {
    field: 'severity',
    headerName: 'Severity',
    renderCell: (params) => (
        <Chip
            label={params.value}
            sx={{ 
                fontSize: '0.5rem',
                backgroundColor: severityColorMap[params.value] || '#757575',
                color: '#fff'
            }}
            size="small"
        />
    )
};

export const hardwareErrorColumns: GridColDef[] = [...baseColumns, severityColumn];

export const hardwareErrorColumnsDetached: GridColDef[] = [...baseColumns, troubleshootingColumn, severityColumn];
